import { useContext } from 'react';
import { QuizContext } from 'core/funnel/contexts';
import { useFlowContent } from './useFlowContent';

export const useEvaluatedFlowAttributesContent = () => {
  const quizContext = useContext(QuizContext);
  const { transformContentToTemplate } = useFlowContent();

  const { flowContent } = quizContext;

  const transformedFlowContent = transformContentToTemplate(flowContent);

  return transformedFlowContent;
};
